import React from "react";
import { Link } from "react-router-dom";
import { FaRobot } from "react-icons/fa"; // Icon for JibuBot
import "./ProductsSection.css"; // Create this based on ServicesSection.css

const Products = ({ isDarkMode }) => {
  const products = [
    {
      title: "JibuBot",
      description: "Smart AI chatbot designed to automate customer support and business communication in Africa.",
      icon: FaRobot,
      link: "jibubot"
    }
    // Future products can be added here
  ];

  return (
    <section className={`products-section ${isDarkMode ? "dark" : "light"}`}>
      <h2>Our Products</h2>
      <div className="products-row">
        {products.map((product, index) => {
          const IconComponent = product.icon;
          return (
            <article key={index} className="product-card">
              <IconComponent className="product-icon" aria-label={product.title} />
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <Link to={`/products/${product.link}`} className="product-button" style={{ textDecoration: "none" }}>
                Learn More
              </Link>
            </article>
          );
        })}
      </div>

      {/* Structured data for SEO */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          "name": "JibuBot",
          "description": "Smart AI chatbot designed to automate customer support and business communication in Africa.",
          "brand": {
            "@type": "Brand",
            "name": "AstraSight Technologies"
          },
          "url": "https://astrasighttech.com/products/Jibubot"
        })}
      </script>
    </section>
  );
};

export default Products;
